module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-email-step"
  }, [_c('h2', {
    staticClass: "aso-email-step__title"
  }, [_vm._v("Digite seu e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-email-step__text"
  }, [_vm._v("Certifique-se de ter acesso ao seu e-mail.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-email-step__text"
  }, [_vm._v("Vamos enviar um código para validá-lo.")]), _vm._v(" "), _c('input', {
    staticClass: "aso-email-step__input",
    attrs: {
      "type": "email",
      "placeholder": "nome@example.com",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:email', $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "aso-email-step__helper"
  }, [_vm._v("Use o formato nome@example.com")]), _vm._v(" "), _c('button', {
    staticClass: "aso-email-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full aso-flow-button--uppercase",
    attrs: {
      "type": "button",
      "disabled": _vm.busy || !_vm.canContinue
    },
    on: {
      "click": function($event) {
        return _vm.$emit('continue')
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.busy ? 'Enviando...' : 'Continuar') + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4247f796"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/AsoValidarEmailStep.vue
// module id = 1484
// module chunks = 45